import axios from 'axios'

import { CalculationServiceApi } from '../../publish/calculation/apis/calculation-service-api'
import { Configuration } from '../../publish/calculation/configuration'
import { setupAxiosInterceptors } from '../axios-interceptor-utils'

export class CalculationService extends CalculationServiceApi {
  constructor(
    protected basePath: string,
    private getTokenFn?: () => Promise<string>,
  ) {
    super(new Configuration({ basePath: basePath }), basePath, axios.create())
    setupAxiosInterceptors(this.axios, this.getTokenFn)
  }
}
